import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/visits/")({
  beforeLoad: () => {
    throw redirect({
      to: "/admin/visits/available-time-slots",
    });
  },
});
